/** 门店销售订单API */
import type { Api } from '@/typings/api';
import { download, post } from '../../request';
const prefix = '/order/storeSaleOrder';
/**
 * 分页查询门店销售订单
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Order.StoreSaleOrder> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询门店销售订单列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Order.StoreSaleOrder> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个门店销售订单
 *
 * @param id 门店销售订单ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Order.StoreSaleOrder> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存门店销售订单
 *
 * @param params 门店销售订单信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新门店销售订单信息
 *
 * @param params 门店销售订单信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除门店销售订单
 *
 * @param id 门店销售订单ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除门店销售订单
 *
 * @param ids 门店销售订单ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};
/**
 * 导出
 *
 * @param params
 * @returns
 */
export const doExport = (params: Api.Common.CommonSearchParams) => {
  return download(`${prefix}/export`, params);
};

/**
 * 挂账支付
 *
 * @param param
 * @returns
 */

export const doCreditPayment = (params: any) => {
  return post(`${prefix}/doCreditPayment`, params);
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete,
  doExport
};
